import "./App.css";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Navbar from "./components/Navbar.jsx";
import MainPage from "./components/MainPage";
import Footer from "./components/Footer";
import {UserProvider} from "./components/UserContext";
import {ThemeProvider} from "./components/ThemeContext";
import SignIn from "./components/SignIn";
import Messages from "./components/Messages";
import Test from "./components/Test";
import AddProject from "./components/AddProject";

function App() {
  return (
    <ThemeProvider>
      <div className="app-shell">
        <Router>
          <UserProvider>
            <Navbar/>
            <main className="app-content">
              <Routes>
                <Route path={"/"} element={<MainPage/>}/>
                <Route path={"/signin"} element={<SignIn/>}/>
                <Route path={"/messages"} element={<Messages/>}/>
                <Route path={"/test"} element={<Test/>}/>
                <Route path={"/add_project"} element={<AddProject/>}/>
              </Routes>
            </main>
            <Footer/>
          </UserProvider>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
